import React from "react";
import Card from "components/card";
import { Clock, GraduationCap } from "lucide-react";
import { Progress } from "antd";

const TrainingClassCard = ({
    recordData,
    isLink = true,
}) => {

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200">
            <div className="p-6">
                <div className="grid md:grid-cols-12 gap-4">
                    <div className="md:col-span-5">
                        <div className="flex items-start gap-3 mb-2">
                            <div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-purple-600">
                                <GraduationCap className="w-5 h-5 text-white" />
                            </div>
                            <div className="flex-1">
                                <h3 
                                    className="font-semibold mb-1"
                                >   
                                    {isLink ? (
                                        <a 
                                            href={`/console/training-classes/${recordData?.tcl_id}/view`}
                                            className="hover:shadow-md cursor-pointer inline-block p-1 px-2 rounded-lg"
                                        >
                                            {recordData?.tcl_title}
                                        </a>
                                    ) : (
                                        <span>{recordData?.tcl_title}</span>
                                    )}
                                </h3>
                                <p className="text-[12px] text-slate-700 mb-2">
                                    {recordData?.tcl_description}
                                </p>
                                <div className="flex flex-wrap gap-2">
                                    <span className="status-indicator normal text-[11px]">
                                        {recordData?.course_cat_name}
                                    </span>
                                    <span className="status-indicator normal text-[11px]">
                                        <Clock className="w-3 h-3 mr-1" />
                                        {recordData?.tcl_duration}
                                    </span>
                                     <span className="status-indicator normal text-[11px]">
                                        ID: {recordData?.tcl_code}
                                    </span>
                                </div>
                                <p className="text-[11px] text-slate-700 mt-2">
                                    Instructor: {recordData?.instructor_name}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="md:col-span-4">
                        <div className="grid grid-cols-3 gap-4">
                            <div>
                                <p className="text-[11px] text-slate-700 mb-1">
                                    Enrolled
                                </p>
                                <p className="text-[18px] font-semibold text-blue-600">
                                    {recordData?.enrolled_count}
                                </p>
                            </div>
                            <div>
                                <p className="text-[11px] text-slate-700 mb-1">
                                    Completed
                                </p>
                                <p className="text-[18px] font-semibold text-green-600">
                                    {recordData?.tcl_completed_count}
                                </p>
                            </div>
                            <div>
                                <p className="text-[11px] text-slate-700 mb-1">
                                    In Progress
                                </p>
                                <p className="text-[18px] font-semibold text-orange-600">
                                    {recordData?.in_progress}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <p className="text-[11px] text-slate-700 mb-2">
                            Completion Rate
                        </p>
                        <div className="flex items-center gap-3">
                            <div className="w-[140px]">
                                <Progress
                                    percent={recordData?.completion_rate}                        
                                    showInfo={false}
                                    strokeWidth={8}
                                    strokeColor="#10B981"                  
                                    trailColor="rgba(16, 185, 129, 0.2)"
                                />
                            </div>
                            <span className="text-[18px] font-semibold text-purple-600">
                                {recordData?.completion_rate} %
                            </span>
                        </div>
                        <p className="text-[10px] text-slate-700 mt-1">
                            {recordData?.enrolled_count}  of {recordData?.tcl_completed_count} completed
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default TrainingClassCard;